import {Component, Input} from '@angular/core';
import {Country, EventItem, Lookups, Race} from "@model";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'my-entry-qr-codes-modal',
  templateUrl: './my-entry-qr-codes-modal.component.html',
  styleUrl: './my-entry-qr-codes-modal.component.scss',
  standalone: false
})
export class MyEntryQrCodesModalComponent {
  @Input({required: true}) languages: Lookups[] = [];
  @Input() countries: Country[] = [];
  @Input() race: Race | undefined;
  @Input() event: EventItem | undefined;
  @Input() registrationConfirmed: boolean = false;

  constructor(public activeModal: NgbActiveModal) {
  }

  ngOnInit() {
  }
}
